import { useEffect, useState } from "react";
import axios from "axios";

//Барааг шүүх Брэнд болон Категорийн сонголтуудыг татна
const useProductFilterOptions = (enabled = true) => {
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [brandLoading, setBrandLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    setBrandLoading(true);
    axios
      .post("/api/v1.0/product/group", { pageSize: 1000 })
      .then(({ data }) => {
        if (data.statusCode === 200) setBrandList(data?.result?.docs ?? []);
      })
      .catch((e) => {
        console.error("Fetch Brand Options: ", e);
      })
      .finally(() => setBrandLoading(false));

    setCategoryLoading(true);
    axios
      .post("/api/v1.0/product/category", { pageSize: 1000 })
      .then(({ data }) => {
        if (data.statusCode === 200) setCategoryList(data?.result?.docs ?? []);
      })
      .catch((e) => {
        console.error("Fetch Category Options: ", e);
      })
      .finally(() => setCategoryLoading(false));
  }, [enabled]);

  return { brandList, categoryList, brandLoading, categoryLoading };
};

export default useProductFilterOptions;
